export default __webpack_public_path__ + "static/boards-manager-screenshot-d376b2c72d2312df77b25459561a34c1.png";